/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class Inventory extends React.Component {
  render() {
    return <div>
      {this.props.children}
    </div>
  }
};
export default Inventory;


// WEBPACK FOOTER //
// ./src/routes/inventory/index.js